var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOffline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 403,
    viewBox: "0 0 403 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.444 0H0V402.444H402.444V0Z",
    fill: "#ECF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.144 308.308C180.239 308.308 189.233 299.304 189.233 288.198C189.233 277.091 180.239 268.088 169.144 268.088C158.049 268.088 149.055 277.091 149.055 288.198C149.055 299.304 158.049 308.308 169.144 308.308Z",
    stroke: "#2064A1",
    strokeWidth: 18.8976,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.776 239.78C133.604 226.938 151.003 219.724 169.144 219.724C187.286 219.724 204.685 226.938 217.513 239.78",
    stroke: "#2064A1",
    strokeWidth: 18.8976,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1406 207.111C98.7781 196.463 111.407 188.016 125.305 182.253C139.204 176.49 154.1 173.524 169.144 173.524C184.188 173.524 199.084 176.49 212.983 182.253C226.881 188.016 239.51 196.463 250.147 207.111",
    stroke: "#2064A1",
    strokeWidth: 18.8976,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5199 175.458C78.1904 153.765 105.653 138.792 135.613 132.333C165.573 125.875 196.758 128.205 225.427 139.046",
    stroke: "#2064A1",
    strokeWidth: 18.8976,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.717 182.282C326.132 182.282 345.924 162.55 345.924 138.209C345.924 113.868 326.132 94.1362 301.717 94.1362C277.302 94.1362 257.509 113.868 257.509 138.209C257.509 162.55 277.302 182.282 301.717 182.282Z",
    stroke: "#2064A1",
    strokeWidth: 18.8977,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.471 153.408L316.962 123.01",
    stroke: "#2064A1",
    strokeWidth: 18.8976,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.471 123.01L316.962 153.408",
    stroke: "#2064A1",
    strokeWidth: 18.8976,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 402.444,
    height: 402.444,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffline);
export default __webpack_public_path__ + "static/media/icon_offline.69825363c8b53362789d74a028cefa72.svg";
export { ForwardRef as ReactComponent };